import { ActionTree } from 'vuex'
import { ConfigurationInfoState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<ConfigurationInfoState, RootState> = {}
